import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type AdditionProps = {
  span?: number;
} & TextInputProps;

export const Addition: React.FC<AdditionProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.addition`}
        label={t(`${TRANS_KEY}.ADDRESS_ADDITION_LABEL`)}
        {...props}
      />
    </Grid.Col>
  );
};
